import React from 'react';
import io from 'socket.io-client';
import { overlayScale } from './leagueOverlay';
import twitchLogo from './images/twitchLogoSquare.png';
import youtubeLogo from './images/youtubeLogoSquare.png';

// Cola para jugar con Narux (apps/cola.js), para OBS:
//   https://forallia.com/?streamGadgets=cola           overlay: las 5 primeras, solo el nombre de jugador
//   https://forallia.com/?streamGadgets=cola&key=...   panel (dock): la cola entera; click = ha entrado a jugar
// La clave es la del panel de recompensas (panelKey de apps/var.js); con la sesion de admin
// tambien sale el panel. &scale=1.4 para el ajuste fino del overlay, como en los demas.
const key = new URLSearchParams(window.location.search).get('key') || '';
const headers = key ? { 'X-Panel-Key': key } : {};
const platformIcons = { twitch: twitchLogo, youtube: youtubeLogo };

const Cola = () => {
    const [data, setData] = React.useState(null);
    // Reembolso en dos clicks, como en el panel de recompensas.
    const [armed, setArmed] = React.useState(null);

    const load = React.useCallback(() => fetch('/api/cola', { credentials: 'include', headers })
        .then(res => res.json())
        .then(setData)
        .catch(err => console.error('Error cargando la cola:', err)), []);

    React.useEffect(() => {
        load();
        const socket = io('https://forallia.com');
        socket.on('cola', load);
        // Tras una reconexion se han podido perder avisos.
        socket.on('connect', load);
        return () => socket.disconnect();
    }, [load]);

    const isPanel = !!(data && data.full);

    // El overlay va sobre la escena: fuera el fondo del html.
    React.useEffect(() => {
        if (!data || isPanel) return;
        document.documentElement.style.backgroundColor = 'transparent';
        document.body.style.overflow = 'hidden';
    }, [data, isPanel]);

    const act = (action, id) => fetch('/api/cola/' + action, {
        method: 'POST',
        credentials: 'include',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
    }).then(load).catch(err => console.error('Error en la cola:', err));

    const refund = (id) => {
        if (armed !== id) {
            setArmed(id);
            setTimeout(() => setArmed(prev => (prev === id ? null : prev)), 3000);
            return;
        }
        setArmed(null);
        act('reembolsar', id);
    };

    if (!data) return null;

    if (key && !isPanel) {
        return <div className='heroes rewardTimerKeyWarn'>La clave de la URL no vale.</div>;
    }

    if (isPanel) {
        return (
            <div className='heroes colaPanel'>
                <div className='rewardsHistory'>{data.game ? 'Cola de ' + data.game + ' (' + data.total + ')' : 'Sin cola: no hay directo o el juego no está en la pestaña Juegos'}</div>
                {data.entries.map(entry => (
                    <div className='infoBox' key={entry.id} title='Ha entrado a jugar' onClick={() => act('jugar', entry.id)}>
                        <div className='colaRow'>
                            {platformIcons[entry.platform] ? <img className='colaPlatform' src={platformIcons[entry.platform]} alt={entry.platform} /> : null}
                            <div className='colaNames'>
                                <span className='colaUser'>{entry.displayname}</span>
                                <span className='colaPlayer userLink'>{entry.name}</span>
                            </div>
                            {entry.paid ? (
                                <button className='copyRewardBtn' onClick={(e) => { e.stopPropagation(); refund(entry.id); }}>
                                    {armed === entry.id ? '¿Seguro?' : 'Reembolsar ' + entry.paid}
                                </button>
                            ) : null}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    // Sin directo, o con un juego sin cola, no pinta nada: la fuente se puede dejar siempre puesta.
    if (!data.game) return null;
    const more = data.total - data.entries.length;
    return (
        <div className='leagueOverlay heroes' style={{ '--overlayScale': overlayScale }}>
            <div className='leagueOverlayBox'>
                <div className='leagueOverlayTitle'>
                    <span className='leagueOverlayGame'>Cola de {data.game}</span>
                    <span className='leagueOverlaySeason'>!cola para entrar</span>
                </div>
                {data.entries.map((entry, i) => (
                    <div className='colaOverlayRow' key={i}>
                        <span className='leagueOverlayPos'>{i + 1}</span>
                        <span className='leagueOverlayName'>{entry.name}</span>
                    </div>
                ))}
                {more > 0 ? <div className='colaOverlayMore'>y {more} más</div> : null}
            </div>
        </div>
    );
};

export default Cola;
